/**
 * 灾害事故路由
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("disasterAccidentRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("front.plan.realtimeclues.suddenclues.disasteraccident.naturaldisaster", {
        url: "/naturaldisaster",
        views: { //自然灾害
            "main@front.plan.realtimeclues.suddenclues.disasteraccident": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/disasterAccident/naturalDisaster/naturalDisaster_tpl.html",
                controller: "naturalDisasterController"
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues.disasteraccident.safetyaccident", {
        url: "/safetyaccident",
        views: {
            "main@front.plan.realtimeclues.suddenclues.disasteraccident": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/disasterAccident/safetyAccident/safetyAccident_tpl.html",
                controller: "safetyAccidentController"
            }
        }
    });
}]);